import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

export function animY() {
    gsap.set(".animY", {y:40, opacity: 0});
        ScrollTrigger.batch(".animY", {
        start: 'top 90%',
        onEnter: batch => gsap.to(batch, {opacity:1, y:0, stagger:0.17}),
        scrub:true
    });
}

export function zoomOut() {
    gsap.set(".zoomOut", {scale:0.8, duration: 0.1});
        ScrollTrigger.batch(".zoomOut", {
        start: 'top 90%',
        onEnter: batch => gsap.to(batch, {scale:1, stagger:0.27}),
        scrub:true
    });
}

export function animazioneHeroHome() {
  const tlHomeHero = gsap.timeline({
            scrollTrigger: {
                trigger: ".hero-home",
                start: "top 80%",
                end: "bottom 20%",
                scrub: 1,
                //markers: true
            }
        });

        tlHomeHero
        .from("#vongola",    {rotate: -80, x:600}, 0)
        .from("#conchiglia", {rotate: 90, x: -600}, 0)


    gsap.to("#bolla", {
        rotate: 360,
        duration: 10,
        repeat: -1,
        ease: "linear"
    });
    gsap.to("#corallo", {
        scale: 1.2,
        rotate: -5,
        duration: 5,
        repeat: -1,
        ease: "linear",
        yoyo: true
    });
    gsap.to("#fascia", {
        scale: 1.1,
        x:40,
        rotate: -12,
        duration: 15,
        repeat: -1,
        ease: "linear",
        yoyo: true
    });
    gsap.to("#fascia-piccola", {
        scale: 1.1,
        x:400,
        rotate: -10,
        duration: 15,
        repeat: -1,
        ease: "linear",
        yoyo: true
    });

}

export function animazioneSezioneMenu() {
    const tlHomeMenu = gsap.timeline({
        scrollTrigger: {
            trigger: ".section-menu-home",
            start: "top 80%",
            end: "bottom 20%",
            duration: 4,
            scrub: 1,
            //markers: true
        }
    });

    tlHomeMenu
    .to("#photo-menu-2", {
        top: '30%',
        left: '45%',
        rotate: 5,
        duration: 1
    }, 0)
    .to("#photo-menu-1", {
        top: '60%',
        left: '70%',
        rotate: -2,
        duration: 0.8
    }, 0)
}

export function animazioneBanner(tag) {
    gsap.to(tag, {
        clipPath: "inset(0% 0%)", // Mostra l'immagine completamente
        scrollTrigger: {
        trigger: tag,
        start: "top 80%", // Inizia quando la sezione è visibile all'80% dall'alto
        end: "top 20%",   // Termina quando la sezione raggiunge il 20% dall'alto
        scrub: 3,       // Sincronizza l'animazione con lo scroll
    }
    });
}